<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormTextInput } from '~/composables/useForm'

const props = defineProps<{
  data: FormTextInput
}>()

const { dt } = useDirectusTranslation()

const validation = computed(() => {
  return [
    props.data.required ? 'required' : null,
  ].join('|')
})
</script>

<template>
  <div>
    
<FormKitLazyProvider config-file="true">
<FormKit
      :id="props.data.key"
      type="text"
      :name="props.data.key"
      :label="dt(props.data.translations)?.label"
      :placeholder="dt(props.data.translations)?.placeholder"
      :validation="validation"
    />
</FormKitLazyProvider>

  </div>
</template>

<style>

</style>
